import { Injectable } from '@angular/core';
import { Site, SiteArea } from '@flyfreely-portal-ui/flyfreely';
import { MODAL_OPTIONS } from '@flyfreely-portal-ui/ngx-bootstrap-customisation';
import { BsModalService } from 'ngx-bootstrap/modal';
import { SiteEditDialogue } from './site-edit/site-edit-dialogue.component';
import { SiteLocationEditComponent } from './site-location-edit/site-location-edit.component';

@Injectable()
export class SiteDialoguesService {
    constructor(private modalService: BsModalService) {}

    showSiteEdit(
        organisationId: number,
        managingOrganisationId: number,
        site: Site | null
    ) {
        return this.modalService.show(SiteEditDialogue, {
            ...MODAL_OPTIONS,
            class: 'modal-md',
            initialState: {
                organisationId,
                managingOrganisationId,
                site: site ?? null
            }
        });
    }

    showSiteLocationEdit(
        organisationId: number,
        siteName: string,
        siteAreas: SiteArea[]
    ) {
        return this.modalService.show(SiteLocationEditComponent, {
            ...MODAL_OPTIONS,
            class: 'modal-lg',
            initialState: {
                organisationId,
                siteName,
                siteAreas: siteAreas ?? []
            }
        });
    }
}
